const BLANK = '-'

export const displayDashIfNotExist = (field) => {
  return field || BLANK
}

export const displayDecimal = (field, decimalPlaces = 2) => {
  return field ? parseFloat(field).toFixed(decimalPlaces) : BLANK
}

export const formatGradingReport = (lab, certificateNumber) => {
  if (lab || certificateNumber) {
    return `${lab || ''} ${certificateNumber || ''}`
  }
  return BLANK
}

export const formatRatio = (ratioField) => {
  return ratioField ? `${parseFloat(ratioField).toFixed(2)}:1` : BLANK
}

export const formatOrigin = (countryOfOriginField) => {
  return countryOfOriginField === 'Canada' ? 'Canadian' : BLANK
}

export const formatRapDiscount = (discountField) => {
  return discountField ? `${parseFloat(discountField * 100).toFixed(0)}%` : 'N/A'
}

export const formatDepth = (depthField) => {
  return depthField && isFinite(depthField) ? `${parseFloat(depthField).toFixed(1)}%` : BLANK
}

export const formatTable = (tableField) => {
  return tableField && isFinite(tableField) ? `${parseFloat(tableField).toFixed(0)}%` : BLANK
}

export const formatCrown = (crownField, crownAngleField, crownHeightField) => {
  if (crownAngleField || crownHeightField) {
    let strHeight = (crownHeightField) ? `${parseFloat(crownHeightField).toFixed(1)}%` : '-'
    let strAngle = (crownAngleField) ? `${parseFloat(crownAngleField).toFixed(1)}°` : '-'
    return `${strHeight}, ${strAngle}`
  } else if (crownField) {
    let parsed = parseFloat(crownField).toFixed(1)
    return parsed === '0.0' ? BLANK : `${parsed}%`
  }
  return BLANK
}

export const formatPavilion = (pavilionField, pavilionAngleField, pavilionDepthField) => {
  if (pavilionAngleField || pavilionDepthField) {
    let strDepth = (pavilionDepthField) ? `${parseFloat(pavilionDepthField).toFixed(1)}%` : '-'
    let strAngle = (pavilionAngleField) ? `${parseFloat(pavilionAngleField).toFixed(1)}°` : '-'
    return `${strDepth}, ${strAngle}`
  } else if (pavilionField) {
    let parsed = parseFloat(pavilionField).toFixed(1)
    return parsed === '0.0' ? BLANK : `${parsed}%`
  }
  return BLANK
}

export const formatSeparable = (isMatchedPairField, isMatchedPairFieldSeparableField) => {
  if (!isMatchedPairField) {
    return BLANK
  }
  return isMatchedPairFieldSeparableField ? 'Yes' : 'No'
}

export const formatFancyIntensity = (field) => {
  if (field === 'F') {
    return 'Faint'
  } else if (field === 'VL') {
    return 'Very Light'
  } else if (field === 'L') {
    return 'Light'
  } else if (field === 'FL') {
    return 'Fancy Light'
  } else if (field === 'FC') {
    return 'Fancy'
  } else if (field === 'FCD') {
    return 'Fancy Dark'
  } else if (field === 'I') {
    return 'Fancy Intense'
  } else if (field === 'FV') {
    return 'Fancy Vivid'
  } else if (field === 'D') {
    return 'Fancy Deep'
  } else {
    return '-'
  }
}

export const formatType = (type) => {
  if (type === 'natural') {
    return 'Natural'
  } else if (type === 'lab') {
    return 'Lab Grown'
  } else {
    return 'Natural'
  }
}



// WEBPACK FOOTER //
// ./src/utils/format-diamond.js